import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SelectedType } from '../searchDates.types';
import { Connect, PropsFromRedux } from './DatesSelectorsContainer';
import { searchConstants } from '../../../../search-utils/searchConstants';
import { RadioInput } from '../RadioInput';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { withUser } from '../../../../../user/UserContext';
import { DateRangeSelector } from './DateRangeSelector';
import { DaySelector } from '../DaySelector';
import { UserContextType } from '../../../../../user/user.types';
import styles from './dates_selectors.module.scss';

type OwnProps = {
  type: string;
};

type Props = {
  defaultDateSelectorSelected: SelectedType;
} & PropsFromRedux &
  UserContextType &
  WithRestrictedModalProps &
  OwnProps;

type State = {
  selectedSelector: SelectedType;
  selectedValue: { from?: string; to?: string; exact?: string };
};

export class RawDatesSelectors extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedSelector: props.defaultDateSelectorSelected || 'all',
      selectedValue: props.selectedValue,
    };
  }

  componentDidUpdate(prevProps: Props) {
    if (
      prevProps.defaultDateSelectorSelected !==
      this.props.defaultDateSelectorSelected
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        selectedSelector: this.props.defaultDateSelectorSelected || 'all',
        selectedValue: this.props.selectedValue,
      });
    }
  }

  handleRadioInput = (
    event: React.MouseEvent<HTMLInputElement, MouseEvent>,
  ) => {
    const { value } = event.currentTarget;
    const { accessPremium, openRestrictedModal, onDatesUpdate } = this.props;

    if (!accessPremium) {
      openRestrictedModal('faceted-item');
    } else {
      let filterSelectorFrom;
      const currentYear = new Date().getFullYear();
      if (value === 'year_now') {
        filterSelectorFrom = currentYear;
      } else if (value === 'year_now_minus_one') {
        filterSelectorFrom = currentYear - 1;
      } else if (value === 'year_now_minus_two') {
        filterSelectorFrom = currentYear - 2;
      } else if (value === 'year_now_minus_four') {
        filterSelectorFrom = currentYear - 4;
      }

      const dateSelectorModel = {
        from: filterSelectorFrom ? String(filterSelectorFrom) : undefined,
        to: undefined,
      };
      doctrineAnalytics('Search DateSelectorClicked', {
        ...dateSelectorModel,
        search_type: this.props.type,
        type: 'custom_year',
      });
      this.setState({
        selectedSelector: value,
        selectedValue: dateSelectorModel,
      } as Pick<State, keyof State>);
      onDatesUpdate(dateSelectorModel);
    }
  };

  handleFakeRadioInput = (
    event: React.MouseEvent<HTMLInputElement, MouseEvent>,
  ) => {
    const { value } = event.currentTarget;
    const { accessPremium, openRestrictedModal } = this.props;

    if (!accessPremium) {
      openRestrictedModal('faceted-item');
    } else {
      const dateSelectorModel = {
        from: undefined,
        to: undefined,
      };

      this.setState({
        selectedSelector: value,
        selectedValue: dateSelectorModel,
      } as Pick<State, keyof State>);
    }
  };

  render() {
    const { accessPremium, openRestrictedModal, onDatesUpdate } = this.props;
    const { selectedSelector, selectedValue } = this.state;

    return (
      <div className={styles.container}>
        <RadioInput
          value="all"
          name="date"
          handleClick={this.handleRadioInput}
          isSelected={selectedSelector === 'all'}
        >
          <FormattedMessage id="search/components/aside-filters/dates/range-selection/DatesSelectors.tsx/1" />
        </RadioInput>
        <RadioInput
          value="year_now"
          name="date"
          handleClick={this.handleRadioInput}
          isSelected={selectedSelector === 'year_now'}
        >
          <FormattedMessage id="search/components/aside-filters/dates/range-selection/DatesSelectors.tsx/2" />
          {searchConstants.years.yearNow}
        </RadioInput>
        <RadioInput
          value="year_now_minus_one"
          name="date"
          handleClick={this.handleRadioInput}
          isSelected={selectedSelector === 'year_now_minus_one'}
        >
          <FormattedMessage id="search/components/aside-filters/dates/range-selection/DatesSelectors.tsx/3" />
          {searchConstants.years.yearNowMinusOne}
        </RadioInput>
        <RadioInput
          value="year_now_minus_four"
          name="date"
          handleClick={this.handleRadioInput}
          isSelected={selectedSelector === 'year_now_minus_four'}
        >
          <FormattedMessage id="search/components/aside-filters/dates/range-selection/DatesSelectors.tsx/4" />
          {searchConstants.years.yearNowMinusFour}
        </RadioInput>

        <RadioInput
          value="date_picker"
          name="date"
          handleClick={this.handleFakeRadioInput}
          isSelected={selectedSelector === 'date_picker'}
        >
          <FormattedMessage id="search/components/aside-filters/dates/range-selection/DatesSelectors.tsx/5" />
        </RadioInput>
        {selectedSelector === 'date_picker' && (
          <DateRangeSelector
            accessPremium={accessPremium}
            openRestrictedModal={openRestrictedModal}
            onDatesUpdate={onDatesUpdate}
            selectedValue={selectedValue}
          />
        )}
        <RadioInput
          value="date_picker_day"
          name="date_picker_day"
          handleClick={this.handleFakeRadioInput}
          isSelected={selectedSelector === 'date_picker_day'}
        >
          <FormattedMessage id="search/components/aside-filters/dates/range-selection/DatesSelectors.tsx/6" />
        </RadioInput>
        {selectedSelector === 'date_picker_day' && (
          <DaySelector
            accessPremium={accessPremium}
            openRestrictedModal={openRestrictedModal}
            onDatesUpdate={onDatesUpdate}
            selectedValue={selectedValue.from}
            type={this.props.type}
            formatDate={(date: string) => ({
              from: date,
              to: date,
            })}
          />
        )}
      </div>
    );
  }
}

export const DatesSelectors = Connect(
  withRestrictedModal(withUser(RawDatesSelectors)),
);
